
import { Component, Emit, Vue } from 'vue-property-decorator'
import lodash from 'lodash'
import { myAccountExchangeFilter } from '@xt/client/dataSource/my/index'
import { EnumMyAccountPacksFilter } from '@xt/client/enums/my'

@Component({})
export default class ExchangeTabsComp extends Vue {
  tabPane: Array<{
    key: number
    title: string
  }> = myAccountExchangeFilter

  defaultActiveKey: number = EnumMyAccountPacksFilter.All
  activeKey: number = +lodash.get(this.$route.query, 'active', EnumMyAccountPacksFilter.All)

  @Emit('change')
  tabsChange(activeKey: string) {
    if (this.activeKey === +activeKey) return

    this.activeKey = +activeKey

    return this.activeKey
  }
}
